export default "__VITE_ASSET__e576f057__"